import RIOStatusBar from '@rio-cloud/rio-uikit/StatusBar';

export type ProgressBarColor = 'bg-gray' | 'progress-bar-success' | 'progress-bar-danger' | 'progress-bar-primary';

export type ProgressBarProgress = {
    percentage?: number;
    color?: ProgressBarColor;
    className?: string;
};

interface ProgressBarProps {
    progress: ProgressBarProgress[];
}

const ProgressBar = ({ progress }: ProgressBarProps) => <RIOStatusBar progress={progress} />;

export default ProgressBar;
